import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import ItemTypeSelect from "./ItemTypeSelect";
import Fields from "./Fields";

export default ({ document, updated, set_show, show }) => {
  const [item_schema, set_item_schema] = useState(document.item_schema);
  const [data, set_data] = useState(document);

  const clear = () => {
    set_data({});
  };
  const close = () => {
    set_show(false);
    // clear();
  };
  const submit = () => {
    updated({ ...data, type: item_schema.csl_slug, item_schema });
    close();
  };

  return (
    <Modal
      size="lg"
      show={show}
      style={{ zIndex: 9999 }}
      onHide={() => {
        set_show(false);
      }}>
      <Modal.Header closeButton>
        <Modal.Title>ویرایش سند</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ItemTypeSelect changed={set_item_schema} value={item_schema} />
        {item_schema ? (
          <Fields schema={item_schema.schema} data={data} set_data={set_data} />
        ) : null}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="warning" onClick={close}>
          انصراف
        </Button>
        <Button
          onClick={clear}
          variant="default"
          style={{ backgroundColor: "#eee" }}>
          پاک کردن
        </Button>
        <Button variant="primary" onClick={submit}>
          تایید
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
